var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A0C0C;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.1,322.7h48.6v162.3c0,15-3.4,28-10.1,39.1c-6.7,11.1-16,19.6-27.9,25.6c-11.9,6-25.7,9-41.5,9 c-14,0-26.7-2.5-38.1-7.4c-11.4-5-20.4-12.5-27.1-22.7c-6.7-10.2-10-23-9.9-38.5h49c0.2,6.1,1.4,11.4,3.8,15.7 c2.4,4.4,5.7,7.7,9.9,10c4.2,2.3,9.2,3.5,14.9,3.5c6.1,0,11.2-1.3,15.4-3.9c4.2-2.6,7.4-6.5,9.6-11.5c2.2-5.1,3.3-11.3,3.3-18.8 V322.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.8,555.4V322.7h91.8c17.7,0,32.7,3.4,45.1,10.1c12.4,6.7,21.9,16,28.5,27.8c6.6,11.9,9.8,25.5,9.8,41 c0,15.5-3.3,29.1-10,40.9c-6.7,11.8-16.3,21-28.9,27.6s-27.9,9.9-45.7,9.9h-58.5v-39.4h50.6c9.5,0,17.3-1.6,23.5-4.9 c6.2-3.3,10.8-7.9,13.9-13.8c3.1-5.9,4.6-12.6,4.6-20.3c0-7.7-1.5-14.5-4.6-20.3c-3.1-5.8-7.7-10.3-13.9-13.5 c-6.2-3.2-14.1-4.8-23.6-4.8H357v192.5H307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.5,322.7h60.7L628.3,479h2.7l64.1-156.4h60.7v232.7h-47.7V403.9h-1.9l-60.2,150.3h-32.5l-60.2-150.9h-1.9 v152h-47.7V322.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpmIcon);
export default __webpack_public_path__ + "static/media/jpm_icon.bc936c79fc099fb274ab025a20d7de00.svg";
export { ForwardRef as ReactComponent };